import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=1aa9e3a6&"
import script from "./CookiePolicy.vue?vue&type=script&lang=js&"
export * from "./CookiePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CookiePolicy.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
  VContainer,
  VFlex,
  VLayout,
})
